$(document).ready(function(){
	$('.designers-slide').slick({
	slidesToShow: 3,
	slidesToScroll: 1,
	autoplay: true,
	autoplaySpeed: 2000,
	speed: 1000,
	mobileFirst:true,
  });

	$('.designers-slide-mobile').slick({
	slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
	speed: 1000,
	mobileFirst:true,
  });

  $('.p-custom-testimonials').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  speed: 1000,
  mobileFirst:true,
  });

	  $(window).on("scroll", function() {
	    if($(window).scrollTop() > 60) {
	        $(".site-header").addClass("white-bg");
	    } else {
	        //remove the background property so it comes transparent again (defined in your css)
	       $(".site-header").removeClass("white-bg");
	    }
	});

	$('.location-selector li a').click(function() {
	  const $this = $(this)
	  const location = $this.attr('class');
	  const $ourHolder = $('.dealer-list');
	  $('.location-selector li a').removeClass('active');
	  $this.addClass('active');

	  if (location === 'all') {
		$ourHolder.children('li.dealer-list_item').fadeIn();
	  } else {
		$ourHolder.children('li:not(.' + location + ')').fadeOut();
		$ourHolder.children('li.' + location).fadeIn();
	  }
	  return false;
	});

	$('.location-selector_mobile').change(function(){
        $(this).find("option:selected").each(function(){
            var location = $(this).attr('class');
			const $ourHolder = $('.dealer-list');

			if (location === 'all') {
	  		$ourHolder.children('li.dealer-list_item').fadeIn();
	  	  } else {
	  		$ourHolder.children('li:not(.' + location + ')').fadeOut();
	  		$ourHolder.children('li.' + location).fadeIn();
	  	  }
        });
    }).change();
});
